
<div class="iframe-container">

  <iframe src="https://blog.scrumpoker-online.org/contact" class="blog-iframe"></iframe>
</div>
